<template>
  <div class="personal-management-pc">
    <a-tabs type="card" v-model:activeKey="activeKey">
      <a-tab-pane key="组织架构" tab="组织架构">
        <department></department>
      </a-tab-pane>

      <a-tab-pane key="人员管理" tab="人员管理">
        <staff></staff>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { defineComponent, ref, provide } from "vue";
import department from "@/views/personnelManagement/component/department/index.vue";
import staff from "@/views/personnelManagement/component/staff/index.vue";

export default defineComponent({
  components: {
    department,
    staff,
  },
  setup() {
    const activeKey = ref("人员管理");

    provide("tabActivekey", activeKey);

    return {
      activeKey,
    };
  },
});
</script>
<style lang="less" scoped>
.personal-management-pc {
  background: #fff;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 20px;
  padding: 15px;
}
</style>
